document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.ps-footer').forEach(function (footer) {
    var tagline = Array.from(footer.querySelectorAll('p')).find(function (p) {
      return p.textContent.trim() === 'Built for pickleball players who sweat, compete and keep playing.';
    });
    if (tagline) tagline.textContent = 'Sweaty grips happen. Paddle Socks handles the break between games.';

    var contact = Array.from(footer.querySelectorAll('a, button')).find(function (el) {
      return el.textContent.trim().toUpperCase().includes('START A CONVERSATION');
    });
    if (contact) {
      contact.textContent = 'TALK TO PADDLE SOCKS';
      if (contact.tagName === 'A') {
        contact.setAttribute('href', '#contact');
        contact.addEventListener('click', function (e) {
          e.preventDefault();
          var trigger = document.querySelector('[data-ps-contact-open]');
          if (trigger) trigger.click();
          else document.querySelector('#contact')?.scrollIntoView({behavior:'smooth'});
        });
      } else {
        contact.setAttribute('type','button');
        contact.addEventListener('click', function () {
          var trigger = document.querySelector('[data-ps-contact-open]');
          if (trigger) trigger.click();
          else document.querySelector('#contact')?.scrollIntoView({behavior:'smooth'});
        });
      }
    }
  });
});
